export const QuestionTypes = {
	Radio: 'radio',
	SchoolSearch: 'schoolSearch',
	UniversitySearch: 'universitySearch',
	TournamentSearch: 'tournamentSearch',
	TournamentEventDetails: 'tournamentEventDetails',
	TournamentEventForm: 'tournamentEventForm',
	ITTProviderSearch: 'ittProviderSearch',
	CountySearch: 'countySearch',
	ParkFinder: 'parkFinder',
	CoachVenueSearch: 'coachVenueSearch',
	ActivatorVenueSearch: 'activatorVenueSearch',
	VenueAddressSearch: 'venueAddressSearch',
	Select: 'select',
	CoachSearch: 'coachSearch',
	SchoolSortCode: 'schoolSortCode',
	DateComponent: 'dateComponent',
	Checkbox: 'checkbox',
	Counter: 'counter',
	FileUpload: 'fileUpload',
	Info: 'info',
	MentorFinder: 'mentorFinder',
	DuetDateComponent: 'duetDateComponent',
	FormTable: 'formTable',
	AffiliatedVenueSearchList: 'affiliateVenueSearchList',
	TextArea: 'textArea',
	AuthorityFinder: 'auhorityFinder',
	PlayerList: 'playerList',
	ContactNumber: 'contactNumber',
	SessionPlayerList: 'sessionPlayerList',
	TextInput: 'textInput',
	AddressFinder: 'addressFinder',
	Checkout: 'checkout',
	ChildContactNumber: 'childContactNumber',
	NurserySearch: 'nurserySearch',
	CollegeSearch: 'collegeSearch',
	TennisLeaderPrimaryVenueSearch: 'tennisLeaderPrimaryVenueSearch'
};

export const FormTypes = {
	StepForm: 'stepForm',
	SectionForm: 'sectionForm'
};
